import { call, put } from "redux-saga/effects";
import { getPreferences, postPreferences } from "../../api/preferencesApi";
import { Types } from "../actionTypes";

export function* doGetPreferences(action) {
  try {
    const response = yield call(getPreferences);
    yield put({
      type: Types.GET_PREFERENCES_SUCCESS,
      response,
    });
  } catch (e) {
    yield put({ type: Types.GET_PREFERENCES_FAILURE });
    console.log("error" + e);
  }
}

export function* doPostPreferences(action) {
  try {
    const response = yield call(postPreferences, action.params);
    yield put({
      type: Types.SET_PREFERENCES_SUCCESS,
      response,
    });
  } catch (e) {
    yield put({ type: Types.SET_PREFERENCES_FAILURE });
    console.log("error" + e);
  }
}
